<template>
	<v-row 
		dense
	>
		<v-col>
			<v-card>
				<!-- <v-card-title
					class = "primary pa-0 body-2"
				>
					{{ $ml.get('options')}}
				</v-card-title> -->
				<v-card-text>
					<v-row
						dense
						no-gutters
					>
						<template
							v-for = "(item_option, idx_option) of info_fields"
						>
							
							<v-col
								:key  = "idx_option"
								class = "mr-1"
							>	
								<v-checkbox
									hide-details
									v-if 	= "	item_option.type == 'check'"
									v-model = "info[item_option.key]"
									:label 	= "item_option.text"
									class 	= "pa-0 ma-2"
								></v-checkbox>
								<dates
									v-if 			   = "	item_option.type == 'date_range' 	|| 
															item_option.type == 'time_picker'"
									:info_to_component = "item_option"
									@receive_info	   = "info[item_option.key] = $event"
								></dates>
									<!-- :info_to_dates 	   = "render_listed(item_option.list)" -->
								<v-btn
									v-if 	= "item_option.type == 'btn'"
									@click 	= "actions(item_option.action)"
								>
									<v-icon
										small
										:color = "item_option.color"
										v-text = "item_option.icon"
										class  = "mr-1" 
									></v-icon>
									{{ item_option.text }}
								</v-btn>
								
							</v-col>
						</template>
					</v-row>
				</v-card-text>
			</v-card>

		</v-col>
		<v-col cols  = "12">
		<v-divider/>
			<v-card>
				<template
					v-for = "(item_list, idx_list) of list"
				>
					
					<v-chip
						small
						:key  = "idx_list"
						color = "blue"
					>
						{{ item_list }}
					</v-chip>
				</template>
			</v-card>
		</v-col>
	</v-row>
</template>
<script>
	import dates 			from "@/components/info/dates.vue"

	export default{
		name : 'records',
		components : {
			dates
		},
		data : () => ({
			info : {},
			info_fields : [
				{
					type 		: 'check',
					key 		: 'is_range',
					text 		: 'with range'
				},
				{
					key 		: 'dates',
					text 		: 'date',
					placeholder : 'select',
					type 		: 'date_range',
					visible 	: true,
					cols 		: {
						col : 2,
					},
				},
				{
					key  : 'get_disk',
					text : 'get space Disk',
					type : 'btn',
					color : 'primary',
					icon  : 'mdi-harddisk'
				},
				{
					key  : 'clear_evidences',
					text : 'Clear images',
					type : 'btn',
					color : 'blue',
					icon : 'mdi-folder-multiple-image'	,


				},
				{
					key  : 'clear_videos',
					text : 'Clear videos',
					type : 'btn',
					color : 'blue darken-1',
					icon : 'mdi-play-box-multiple',
				}
			],
			list : [],
		}), // data

		methods : {
			
			actions(act, item, opt){
				if (act == 'get_disk') {
					this.get_list();
				}		
				if (act == 'clear_evidences') {

				}
				if (act == 'clear_videos') {

				}
			}, // actions

			get_list(){
				const api = this.$URL + '';
				this.$axios.get(api).then( res => {
					console.log("Get records disk : ", res);
				}).catch( er => {
					console.log( "Error get records disk ", er);
				});
			}, // get list

			clear(act){
				let info_up = this.info;

				const api = this.$URL + '';
				this.$axios.post(api, info_up).then( res => {
					console.log("Get records disk : ", res);
				}).catch( er => {
					console.log( "Error get records disk ", er);
				});
			}

		}, // methods

	}; // export default
</script>